import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';

declare var bootstrap: any;

@Component({
  selector: 'app-reports-scheduling',
  templateUrl: './reports-scheduling.component.html',
  styleUrls: ['./reports-scheduling.component.scss']
})
export class ReportsSchedulingComponent implements OnInit {

  reports: any;
  monitors: any;
  groups: any = [];
  edit_report: any;
  filter: any = [];

  sort = 'name';
  monitor: any;
  group: any;

  freq: any = [
    {name: 'Yearly', value:'yearly'},
    {name: 'Monthly', value:'monthly'},
    {name: 'Weekly', value:'weekly'},
    {name: 'Daily', value:'daily'}
  ];

  type: any = [
    {name: 'No Location', value:'no_location'},
    {name: 'Actions Stats', value:'worker_stats'},
    {name: 'App Not Activated', value:'app_not_activated'},
    {name: 'Current Status', value:'worker_status'},
    {name: 'Has Started A Shift', value:'has_started_a_shift'},
    {name: 'No Shift Started', value:'no_shift_started'},
    {name: 'Last Shift Started', value:'last_shift_started'},
    {name: 'Short Shifts', value:'short_shifts'},
    {name: 'Daily Group Count', value:'daily_group_count'},
    {name: 'Man Down Settings', value:'mandown_settings'},
    {name: 'Timesheets', value:'timesheets'},
    {name: 'Location Settings', value:'location_settings'}
  ];

  createFormGroup:any;

  editFormGroup: any;

  submitted = false;

  form_error = "";

  pagination = { page: 1, pageSize: 1, itemCount: 1, totalPages: 1, pageArray: [1], totalCount: 1 };

  get f(): { [key: string]: AbstractControl } {
    return this.createFormGroup.controls;
  }

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, public transloco: TranslocoService) { }

  ngOnInit(): void {

    this.pagination.page = 1;
    this.getReports();
    this.setupCreateForm();

  }

  setupCreateForm(){
    this.createFormGroup = new FormGroup ({
      type: new FormControl(null,[Validators.required]),
      freq: new FormControl(null,[Validators.required]),
      monitors: new FormControl(null,[Validators.required]),
      filter: new FormGroup ({
        monitor: new FormControl(null,[]),
        group: new FormControl(null,[])
      })
    });
  }

  getReports(){

    let filter = {
      sort: this.sort,
      page: this.pagination.page
    }
    //console.log('filter',filter);

    this.okService.get("reportschedules",filter)
    .subscribe((data: any) => {

      this.reports = data.body;
      this.pagination = this.okService.setPagination(data.headers) ?? this.pagination;
      //console.log('reports',this.reports);

    });

  }

  updateFilter(){
    this.getReports();
  }

  createReport(){
    //console.log('click create',this.createFormGroup.value)
    this.submitted = true;
    this.form_error = "";

    if(this.createFormGroup.valid){

      let values = this.createFormGroup.value;
      //console.log('create values',values);

      this.okService.post("reportschedules",values)
      .subscribe((data: any) => {

        const collapse = new bootstrap.Collapse('#collapseCreate', {
          toggle: false
        })
        collapse.hide();

        this.getReports();
        this.setupCreateForm();


        this.okService.setAlert(this.transloco.translate("The report was created"),"success");

      });
    }else{
      this.form_error = this.transloco.translate("Please choose a type, frequency and who to send the alert too.");
    }
  }

  editReport(report: any){
    this.edit_report = report;
    //console.log('this report',this.edit_report)

    this.editFormGroup = new FormGroup ({
      type: new FormControl(this.edit_report.type,[Validators.required]),
      freq: new FormControl(this.edit_report.freq,[Validators.required]),
      monitors: new FormControl(this.edit_report.monitor_ids,[Validators.required]),
      filter: new FormGroup ({
        monitor: new FormControl(this.edit_report.filter['monitor'],[]),
        group: new FormControl(this.edit_report.filter['group'],[])
      })
    });

    //console.log(this.editFormGroup.value);

    var myModal = new bootstrap.Modal(document.getElementById('editReportModal'));

    myModal.show();

  }

  submitEditReport(){

    //console.log('click edit',this.editFormGroup.value);
    this.submitted = true;
    this.form_error = "";

    if(this.editFormGroup.valid){

      let values = this.editFormGroup.value;
      //console.log('edit values',values);

      this.okService.put("reportschedules/"+this.edit_report.id,values)
      .subscribe((data: any) => {
        this.getReports();

        this.okService.setAlert(this.transloco.translate("The report was updated"),"success");

        var myModal = bootstrap.Modal.getOrCreateInstance(document.getElementById('editReportModal'));
        myModal.hide();

      });
    }else{
      this.form_error = this.transloco.translate("Please choose a type, frequency and who to send the alert too.");
    }
  }

  doDelete(){
    if(confirm(this.transloco.translate("Are you sure you want to delete this report?"))) {

      this.okService.delete('reportschedules/'+this.edit_report.id)
      .subscribe((data: any) => {

        this.okService.setAlert(this.transloco.translate("We have deleted this report for you"),"success");

        var myModal = bootstrap.Modal.getOrCreateInstance(document.getElementById('editReportModal'));

        myModal.hide();

        this.getReports();
      }
      );
  }
  }

}
